import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { Alert, Icon, ImageSelectItem, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { StatesOfOperationField } from "../forms/fields";
import { SignUpOperatorFormData } from "../forms/types";

export const SignUpFormOperatorStep1 = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const { setValue } = useFormContext<SignUpOperatorFormData>();
  const [isAuthorised, setIsAuthorised] = useState<boolean>();

  return (
    <div className={clsx("relative animate-enter", className)} {...props}>
      <Typography variant="title">Are you an authorised transport provider in your state?</Typography>
      <div className="mt-4 flex flex-row gap-5">
        <ImageSelectItem
          label="Yes"
          icon={<Icon name="TickCircle" variant="Bold" size={48} className="text-success" />}
          selected={isAuthorised}
          onClick={() => setIsAuthorised(true)}
          className="h-32 !w-full"
        />
        <ImageSelectItem
          label="No"
          icon={<Icon name="CloseCircle" variant="Bold" size={48} className="text-danger" />}
          selected={isAuthorised === false}
          onClick={() => {
            setIsAuthorised(false);
            setValue("statesOfOperation", [], { shouldDirty: true });
          }}
          className="h-32 !w-full"
        />
      </div>
      {isAuthorised === false && (
        <Alert
          type="warning"
          message="This platform is designed for authorized transport operators, please revisit this site once you are authorized"
          className="mt-6"
        />
      )}
      {isAuthorised && <StatesOfOperationField className="mt-8" />}
    </div>
  );
};
